interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetXCreateState {
    quickbetXCreateData: any;
    quickbetXCreateLoading: boolean;
    quickbetXCreatError: ErrorResponse | null;
}


export enum QuickbetXCreateActionTypes {
    FETCH_QUICKBET_X_CREATE_DATA = "FETCH_QUICKBET_X_CREATE_DATA",
    FETCH_QUICKBET_X_CREATE_DATA_SUCCESS = "FETCH_QUICKBET_X_CREATE_DATA_SUCCESS",
    FETCH_QUICKBET_X_CREATE_DATA_ERROR = "FETCH_QUICKBET_X_CREATE_DATA_ERROR",
}

export type QuickbetXCreateAction =
    | { type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA }
    | { type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_SUCCESS; payload: any[] }
    | { type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_ERROR; payload: any };